import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=15726995&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=15726995&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports